import * as moment from 'moment';

export function setTimeToMidnight(date: Date): Date {
  return moment(date).startOf('day').toDate();
}

/**
 * Return a plain `YYYY-MM-DD` string (date-only) from a Moment object.
 */
export function extractDateString(date: moment.Moment): string {
  return date.format('YYYY-MM-DD');
}
